import { createFileRoute } from "@tanstack/react-router";
import { SignupFlow, type SignupSearch, type SignupStep } from "./-signup/SignupFlow";

const STEPS: SignupStep[] = ["email", "code", "passkey", "workspace", "plan", "welcome"];
const str = (v: unknown) => (typeof v === "string" && v.length > 0 && v.length < 200 ? v : undefined);

export const Route = createFileRoute("/signup")({
  validateSearch: (s: Record<string, unknown>): SignupSearch => {
    const out: SignupSearch = {};
    if (STEPS.includes(s.step as SignupStep)) out.step = s.step as SignupStep;
    if (str(s.invite)) out.invite = str(s.invite);
    if (str(s.invitation)) out.invitation = str(s.invitation);
    if (str(s.ws)) out.ws = str(s.ws);
    if (str(s.email)) out.email = str(s.email);
    return out;
  },
  staticData: { title: "Create your account" },
  component: SignupFlow,
});
